import { ButtonProps } from '@/models/widgets/props/button';
import { Rating5StarProps } from '@/models/widgets/props/rating-5-star';
import { TextareaFieldProps } from '@/models/widgets/props/textarea-field';
import { TextFieldProps } from '@/models/widgets/props/text-field';
import { SelectFacilityProps } from '@/models/widgets/props/select-facility';
import { MultipleSelectProps } from '@/models/widgets/props/multiple-select';
import { HeaderProps } from '@/models/widgets/props/header';
import { ImageProps } from '@/models/widgets/props/image';
import { TextProps } from '@/models/widgets/props/text';
import { LinkProps } from '@/models/widgets/props/link';
import { AiGeneratedTextFieldProps } from '@/models/widgets/props/ai-generated-text-field';
import { SingleSelectProps } from '@/models/widgets/props/single-select';
import { GroupingElement } from '@/models/widgets/props/grouping-element';
import { CheckboxProps } from '@/models/widgets/props/checkbox';
import { COMPONENT_TYPES } from '@/models/enums/component-types.enum';
import { WidgetPropsUnion } from '@/models/widgets/widget-props-union';

export const WidgetsPropsMap: Record<COMPONENT_TYPES, WidgetPropsUnion> = {
  [COMPONENT_TYPES.BUTTON]: ButtonProps,
  [COMPONENT_TYPES.TEXT_ELEMENT]: TextProps,
  [COMPONENT_TYPES.RATING_5_STARS_ELEMENT]: Rating5StarProps,
  [COMPONENT_TYPES.TEXTAREA_FIELD]: TextareaFieldProps,
  [COMPONENT_TYPES.TEXT_FIELD_ELEMENT]: TextFieldProps,
  [COMPONENT_TYPES.SELECT_FACILITY_ELEMENT]: SelectFacilityProps,
  [COMPONENT_TYPES.HEADING_TEXT_ELEMENT]: HeaderProps,
  [COMPONENT_TYPES.IMAGE_ELEMENT]: ImageProps,
  [COMPONENT_TYPES.LINK_ELEMENT]: LinkProps,
  [COMPONENT_TYPES.AI_GENERATED_TEXT_AREA_ELEMENT]: AiGeneratedTextFieldProps,
  [COMPONENT_TYPES.SINGLE_SELECT_ELEMENT]: SingleSelectProps,
  [COMPONENT_TYPES.SINGLE_BUTTON_SELECT_ELEMENT]: SingleSelectProps,
  [COMPONENT_TYPES.MULTIPLE_SELECT_ELEMENT]: MultipleSelectProps,
  [COMPONENT_TYPES.GROUPING_ELEMENT]: GroupingElement,
  [COMPONENT_TYPES.CHECKBOX_ELEMENT]: CheckboxProps,
  [COMPONENT_TYPES.SOCIAL_MEDIA_SHARE_ELEMENT]: CheckboxProps,
};
